import React, { MouseEvent } from 'react'
import { Link, NavLink } from 'react-router-dom'

import DropdownButton from 'js/components/DropdownButton/DropdownButton'
import LinkItem from 'js/components/LinkItem/LinkItem'

import ChevronDownIcon from 'icons/chevron-down-small.svg'

type focusEvent = MouseEvent<HTMLButtonElement | HTMLAnchorElement>

// Restore focus on activated menu item
const restoreFocus = (event: focusEvent) => {
    setTimeout(() => {
        if (event.target instanceof HTMLElement) {
            event.target.focus()
        }
    }, 0)
}

const NavMenuItem = ({ item, counter }: { item: any; counter: number }) => {
    if (item.options?.length > 0) {
        const itemOptions = item.options
            // Sometimes items are undefined, filter them out
            .filter(Boolean)
            // Only include items with a label and a to or url
            .filter(({ label, to, url }) => label && (to || url))
            .map(({ label, to, url }) => {
                return {
                    name: label,
                    ...(to ? { to } : {}),
                    ...(url ? { url } : {}),
                }
            })

        return (
            <DropdownButton
                key={counter}
                options={itemOptions}
                trigger="click mouseenter"
                placement="bottom-start"
                arrow
                wrapContent
                showArrow
                arrowElement={<ChevronDownIcon style={{ marginLeft: '4px' }} />}
            >
                <button
                    key={counter}
                    type="button"
                    className="MenuItem"
                    onClick={restoreFocus}
                >
                    {item.label}
                </button>
            </DropdownButton>
        )
    }

    if (item.to !== undefined) {
        return (
            <NavLink
                key={counter}
                id={item.id}
                to={item.to}
                end={!!item.end}
                className="MenuItem"
                onClick={restoreFocus}
            >
                {item.label}
            </NavLink>
        )
    }

    if (item.link !== undefined) {
        return (
            <Link
                key={counter}
                id={item.id}
                to={item.link}
                className="MenuItem"
                onClick={restoreFocus}
            >
                {item.label}
            </Link>
        )
    }

    if (item.url !== undefined) {
        return (
            <LinkItem
                key={counter}
                id={item.id}
                url={item.url}
                className="MenuItem"
            >
                {item.label}
            </LinkItem>
        )
    }
    return null
}

export default NavMenuItem
